// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5UXIe","top":"styles_top__2T8WX"};